import { Component } from '@angular/core';

@Component({
    selector: 'app-anothersolutionwrapper',
    imports: [],
    templateUrl: './anothersolutionwrapper.component.html',
    styleUrl: './anothersolutionwrapper.component.css'
})
export class AnothersolutionwrapperComponent {

}
